<script>
    import {
        // Select,
        Typography,
        TextArea,
        // Row,
        // Alert
    } from '../UI'
    import InputTable from '../UI/InputTable.svelte'
    import { isPdf, validarCuit } from '$lib/utils'
    import {ENV} from '$lib/conf'
    import { API_URL } from '$lib/conf'
    export let data = {}
    export let inputs = null
    export let editable = true
    export const valid = true
    export const dynamic = true
    $: allowedInputs = inputs instanceof Array ? inputs : []
    $: showAll = !(allowedInputs.length > 0)
    // function allowInput(n) {
    //   return showAll || allowedInputs.includes(n);
    // }
    // const validRow = row => Object.values(row).every(c => c instanceof Array ? (c.length > 0 ? isPdf(c[0]?.fileId) : false) : c !== '');
    let validTable
    const validRow = (row) =>
        Object.values(row).every((c) =>
            c instanceof Array
                ? c.length > 0
                    ? isPdf(c[0]?.fileId)
                    : false
                : c !== ''
        )
    const truncate = (str, n = 20, center = true) => {
        let len = str.length
        if (center) {
            return (
                str.substr(0, Math.floor((n - 1) / 2)) +
                '...' +
                str.substr(Math.floor(((n - 2) / 2) * -1))
            )
        } else {
            return str.substr(0, len - n - 3) + '...'
        }
    }
    const renderITableFileRow = (x) => {
        const icon = `
      <svg style="display: inline-block; width: 1em; height: 1em;" viewbox="0 0 48 48">
        <path fill="#00669E" d="M36 24c-1.2 0-2 0.8-2 2v12c0 1.2-0.8 2-2 2h-22c-1.2 0-2-0.8-2-2v-22c0-1.2 0.8-2 2-2h12c1.2 0 2-0.8 2-2s-0.8-2-2-2h-12c-3.4 0-6 2.6-6 6v22c0 3.4 2.6 6 6 6h22c3.4 0 6-2.6 6-6v-12c0-1.2-0.8-2-2-2z"></path>
        <path fill="#00669E" d="M43.8 5.2c-0.2-0.4-0.6-0.8-1-1-0.2-0.2-0.6-0.2-0.8-0.2h-12c-1.2 0-2 0.8-2 2s0.8 2 2 2h7.2l-18.6 18.6c-0.8 0.8-0.8 2 0 2.8 0.4 0.4 0.8 0.6 1.4 0.6s1-0.2 1.4-0.6l18.6-18.6v7.2c0 1.2 0.8 2 2 2s2-0.8 2-2v-12c0-0.2 0-0.6-0.2-0.8z"></path>
      </svg>
    `
        const winOpen = (fielname, linkId) =>
            `window.open('${API_URL}/download/${linkId.replace(/\.pdf/i, '')}/preview','${fielname}','menubar=no,location=no,resizable=no,width=420,height=594,scrollbars=yes,status=no')`
        if (x instanceof Array && x.length > 0) {
            const filename = x[0]?.filename
            return `
      <strong
        onclick="${winOpen(filename, x[0]?.fileId)}"
        style="cursor: pointer"
        title="${filename}"
      >
      ${truncate(filename, 15, true)} ${icon}
      </strong>`
        } else if (typeof x === 'string' && /^[0-9]+$/.test(x)) {
            return `<strong style="cursor: pointer" onclick="${winOpen('Adjunto', x)}">Ver Adjunto ${icon}</strong>`
        } else {
            return '<Unknow>'
        }
    }

    const fileValidation = (x) =>
        x instanceof Array &&
        x.length > 0 &&
        x.every(({ filename }) => isPdf(filename))
    const isCuentaCorriente = (x) => x && /^[0-9]{20}$/.test(x)

    let schema = {
        cuil: {
            label: 'CUIL',
            validation: (r) => r && validarCuit(r),
            props: {
                maxLength: 11,
            },
        },
        nombre: {
            type: 'string',
            validation: (x) => x,
            props: {
                maxLength: 60,
            },
        },
        apellido: {
            type: 'string',
            validation: (x) => x,
            props: {
                maxLength: 60,
            },
        },
        cuenta_corriente: {
            label: 'Cuenta Corriente',
            hidden: true,
            validation: isCuentaCorriente,
            props: {
                maxLength: 20,
            },
        },
        clave_de_alta_temprana: {
            label: 'Clave de alta temprana',
            hidden: true,
        },
        constancia_pago_remuneracion: {
            label: 'Constancia de Pago de Remuneriación',
            type: 'file',
            render: renderITableFileRow,
            validation: fileValidation,
            props: {
                endpoint: API_URL + '/upload',
                style: 'margin-bottom: 15px',
            },
        },
        cobertura_de_riesgo_de_trabajo: {
            label: 'Cobertura de riesgo de trabajo',
            hidden: true,
            validation: (x) => x,
            props: {
                maxLength: 20,
            },
        },
        copia_pago_seguridad: {
            label: 'Copia de comprobante de pago de seguridad',
            type: 'file',
            render: renderITableFileRow,
            validation: fileValidation,
            props: {
                endpoint: API_URL + '/upload',
                style: 'margin-bottom: 15px',
            },
        },
    }
</script>

<Typography type="body" color="grey-800"
    >Complete la siguiente tabla si tiene empleados trabajando en instalaciones
    de {ENV.COMPANY_NAME} (Opcional).</Typography
>
<InputTable
    bind:value={data.empleados}
    bind:valid={validTable}
    validation={(d) =>
        d instanceof Array && d.length > 0 && d.every((r) => validRow(r))}
    {schema}
    buttonLabel="Agregar empleado"
/>
<TextArea
    bind:value={data.observaciones_lp}
    disabled={!editable}
    name="observaciones_lp"
    label="Observaciones"
/>
